import type { AgentStep } from "../runner/types";
import { aiCheckStep } from "./aiCheckStep";
import { aiReadingStep } from "./aiReadingStep";
import { aiRetryStep } from "./aiRetryStep";
import { autoSortStep } from "./autoSortStep";
import { bankContactsStep } from "./bankContactsStep";
import { bankImportStep } from "./bankImportStep";
import { documentContactsStep } from "./documentContactsStep";
import { draftsFromDocumentsStep } from "./draftsFromDocumentsStep";
import { draftsFromTransactionsStep } from "./draftsFromTransactionsStep";
import { fillBankStep } from "./fillBankStep";
import { kasseFromDocumentsStep } from "./kasseFromDocumentsStep";
import { postingRulesStep } from "./postingRulesStep";
import { reconcileStep } from "./reconcileStep";
import { reportStep } from "./reportStep";
import { sortQuestionsStep } from "./sortQuestionsStep";
import { startStep } from "./startStep";
import { uploadStep } from "./uploadStep";

/** The scenario in the order the spec's table fixes; the order is data, so a test pins it. */
export const AGENT_STEPS: AgentStep[] = [
    startStep,
    uploadStep,
    aiReadingStep,
    aiRetryStep,
    autoSortStep,
    sortQuestionsStep,
    documentContactsStep,
    kasseFromDocumentsStep,
    bankImportStep,
    bankContactsStep,
    draftsFromDocumentsStep,
    draftsFromTransactionsStep,
    fillBankStep,
    reconcileStep,
    aiCheckStep,
    postingRulesStep,
    reportStep,
];
